<template>
  <v-menu bottom left min-width="150" v-if="canTransition">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" icon small class="mr-2">
        <v-icon small v-text="$vuetify.icons.values.forward" />
      </v-btn>
    </template>
    <v-list dense>
      <template v-for="(transition, idx) in item.transitions">
        <v-list-item :key="idx" @click="requestTransition({ item, transition })">
          <v-list-item-title>{{ getStateDisplay(transition.to_state) }}</v-list-item-title>
        </v-list-item>
      </template>
    </v-list>
  </v-menu>
</template>

<script>
import entityPerimeter from '../perimeters'

export default {
  name: 'EntityStateMenu',
  perimeters: [entityPerimeter],
  props: {
    item: Object,
    states: Array,
    requestTransition: Function
  },
  computed: {
    hasTransitions() {
      return this.item && this.item.transitions && this.item.transitions.length > 0
    },
    canTransition() {
      return this.hasTransitions && this.$entity.isAllowed('update', this.item.entity)
    }
  },
  methods: {
    getStateDisplay(name) {
      let match = this.states.find((state) => state.name === name)
      if (match) return this.$t(`labels.${match.display}`)
      return this.$t(`labels.${name}`)
    }
  }
}
</script>
